"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComparisonGranularity = exports.getNumberOfUnitsOrAmount = exports.definitionWithComparison = exports.getComparisonFromDefinitionAndFlags = exports.makeMarkBasedOrHistoricalComparisonSpec = exports.defaultComparisonForGranularity = exports.defaultComparisonSchema = exports.COMPARISON_TIMESTAMP_COLUMN_NAME = exports.COMPARISON_MEASURE_COLUMN_NAME = void 0;
var models_1 = require("../../models");
var ComparisonSpecType_1 = require("../../models/comparisonSpec/ComparisonSpecType");
var RowShiftCalculation_1 = require("../../transforms/calculations/RowShiftCalculation");
var TimeShiftCalculation_1 = require("../../transforms/calculations/TimeShiftCalculation");
var metricValue_1 = require("../metricValue");
var status_1 = require("../status");
var threshold_1 = require("../threshold");
var defaults_1 = require("./defaults");
Object.defineProperty(exports, "COMPARISON_TIMESTAMP_COLUMN_NAME", { enumerable: true, get: function () { return defaults_1.COMPARISON_TIMESTAMP_COLUMN_NAME; } });
Object.defineProperty(exports, "COMPARISON_MEASURE_COLUMN_NAME", { enumerable: true, get: function () { return defaults_1.COMPARISON_MEASURE_COLUMN_NAME; } });
var defaultComparisonSchema = function (timestampColumnRef, measureColumnRef, granularity) {
    var _a;
    var comparison = (0, exports.defaultComparisonForGranularity)(granularity);
    return _a = {},
        _a[defaults_1.COMPARISON_TIMESTAMP_COLUMN_NAME] = {
            type: 'datetime',
            name: defaults_1.COMPARISON_TIMESTAMP_COLUMN_NAME,
            calculation: calculationForComparison(comparison),
        },
        _a[defaults_1.COMPARISON_MEASURE_COLUMN_NAME] = {
            type: 'number',
            name: defaults_1.COMPARISON_MEASURE_COLUMN_NAME,
        },
        _a;
};
exports.defaultComparisonSchema = defaultComparisonSchema;
var defaultComparisonForGranularity = function (granularity) {
    if (granularity === models_1.DateGranularity.UNKNOWN) {
        return (0, models_1.makeMarkBasedComparisonSpec)('', 1);
    }
    else {
        return (0, models_1.makeHistoricalComparisonSpec)((0, models_1.dateTruncFromGranularity)(granularity), '', 1);
    }
};
exports.defaultComparisonForGranularity = defaultComparisonForGranularity;
var makeMarkBasedOrHistoricalComparisonSpec = function (numberOfUnits, dateTrunc, shouldShowComparisonLine) {
    return dateTrunc === models_1.DateTrunc.UNKNOWN
        ? (0, models_1.makeMarkBasedComparisonSpec)('', numberOfUnits)
        : (0, models_1.makeHistoricalComparisonSpec)(dateTrunc, '', numberOfUnits, shouldShowComparisonLine);
};
exports.makeMarkBasedOrHistoricalComparisonSpec = makeMarkBasedOrHistoricalComparisonSpec;
var getComparisonFromDefinitionAndFlags = function (flags, definition) {
    var dateGranularity = (0, metricValue_1.getTimestampGranularity)(definition);
    var dateTrunc = (0, models_1.dateTruncFromGranularity)(dateGranularity);
    if (flags.isReferenceLineEnabled && (0, threshold_1.isDefaultLineStaticRefLine)(definition)) {
        var staticTargetValue = (0, threshold_1.getStaticTargetValue)(definition);
        return staticTargetValue === undefined ? undefined : (0, models_1.makeStaticComparisonSpec)('', staticTargetValue);
    }
    if (flags.isHistoricalComparisonsEnabled) {
        var numberOfUnits = (0, exports.getNumberOfUnitsOrAmount)(definition);
        var shouldShowComparisonLine = flags.isReferenceLineEnabled && (0, threshold_1.shouldRenderFirstThresholdLine)(definition);
        return numberOfUnits === undefined
            ? undefined
            : (0, exports.makeMarkBasedOrHistoricalComparisonSpec)(numberOfUnits, dateTrunc, shouldShowComparisonLine);
    }
    return (0, exports.defaultComparisonForGranularity)(dateGranularity !== null && dateGranularity !== void 0 ? dateGranularity : models_1.DateGranularity.UNKNOWN);
};
exports.getComparisonFromDefinitionAndFlags = getComparisonFromDefinitionAndFlags;
var definitionWithComparison = function (definition, comparison, hideThresholdLine) {
    var comparisonName = 'comparison';
    if ((0, ComparisonSpecType_1.isStaticComparison)(comparison)) {
        return (0, threshold_1.definitionWithStaticTarget)(definition, comparison.value);
    }
    var newFeatures = makeFeaturesWithComparison(hideThresholdLine, comparison, definition);
    var newSchema = makeSchemaWithComparison(definition, comparison, comparisonName);
    return __assign(__assign({}, definition), { features: newFeatures, schema: newSchema });
};
exports.definitionWithComparison = definitionWithComparison;
var getNumberOfUnitsOrAmount = function (definition) {
    var _a;
    if ((0, threshold_1.isDefaultLineStaticRefLine)(definition)) {
        return undefined;
    }
    var line = (0, threshold_1.getDefaultLineForThreshold)(definition.features.threshold);
    if ((line === null || line === void 0 ? void 0 : line.timestamp) === undefined) {
        return undefined;
    }
    var timestampCalculation = definition.schema[line.timestamp.column].calculation;
    return (_a = timestampCalculation === null || timestampCalculation === void 0 ? void 0 : timestampCalculation.numberOfUnits) !== null && _a !== void 0 ? _a : timestampCalculation === null || timestampCalculation === void 0 ? void 0 : timestampCalculation.amount;
};
exports.getNumberOfUnitsOrAmount = getNumberOfUnitsOrAmount;
var getComparisonGranularity = function (definition) {
    if ((0, threshold_1.isDefaultLineStaticRefLine)(definition)) {
        return undefined;
    }
    var line = (0, threshold_1.getDefaultLineForThreshold)(definition.features.threshold);
    if ((line === null || line === void 0 ? void 0 : line.timestamp) === undefined) {
        return undefined;
    }
    var timestampCalculation = definition.schema[line.timestamp.column].calculation;
    if (!timestampCalculation) {
        return undefined;
    }
    return timestampCalculation.granularity;
};
exports.getComparisonGranularity = getComparisonGranularity;
var makeFeaturesWithComparison = function (hideThresholdLine, comparison, definition) {
    var definitionWithoutStatus = __assign({}, definition.features);
    delete definitionWithoutStatus[status_1.STATUS_FEATURE_NAME];
    if ((0, ComparisonSpecType_1.isNoComparison)(comparison)) {
        // No comparison was set so remove the existing thresholds
        return __assign(__assign({}, definitionWithoutStatus), { threshold: {} });
    }
    // For now, we're swapping a new threshold if one already exists because we can (at the moment) only
    // have one threshold applied to a metric
    var newThresholdLine = {
        measure: { column: defaults_1.COMPARISON_MEASURE_COLUMN_NAME },
        timestamp: { column: defaults_1.COMPARISON_TIMESTAMP_COLUMN_NAME },
        style: __assign(__assign({}, (0, threshold_1.defaultThresholdLineStyle)()), { hidden: hideThresholdLine }),
    };
    var newThreshold = {
        thresholds: [
            {
                lines: [newThresholdLine],
            },
        ],
    };
    var newFeatures = __assign(__assign({}, definitionWithoutStatus), { threshold: newThreshold });
    return newFeatures;
};
var makeSchemaWithComparison = function (definition, comparison, comparisonName) {
    var _a;
    if ((0, ComparisonSpecType_1.isNoComparison)(comparison)) {
        // No comparison was set so don't modify the schema
        return __assign({}, definition.schema);
    }
    return __assign(__assign({}, definition.schema), (_a = {}, _a[defaults_1.COMPARISON_TIMESTAMP_COLUMN_NAME] = {
        type: 'datetime',
        name: defaults_1.COMPARISON_TIMESTAMP_COLUMN_NAME,
        calculation: calculationForComparison(comparison),
    }, _a[defaults_1.COMPARISON_MEASURE_COLUMN_NAME] = {
        type: 'number',
        name: defaults_1.COMPARISON_MEASURE_COLUMN_NAME,
    }, _a));
};
var calculationForComparison = function (comparison) {
    var _a;
    if ((0, ComparisonSpecType_1.isHistoricalComparisonSpec)(comparison)) {
        return {
            type: TimeShiftCalculation_1.TimeShiftType,
            source: { column: metricValue_1.TIMESTAMP_COLUMN_NAME },
            granularity: (0, models_1.dateGranularityFromTrunc)(comparison.comparisonPeriod),
            numberOfUnits: (_a = comparison.numberOfPeriods) !== null && _a !== void 0 ? _a : 1,
            copy: [{ from: { column: metricValue_1.MEASURE_COLUMN_NAME }, to: { column: defaults_1.COMPARISON_MEASURE_COLUMN_NAME } }],
        };
    }
    else if ((0, ComparisonSpecType_1.isMarkBasedComparison)(comparison)) {
        return {
            type: RowShiftCalculation_1.RowShiftType,
            amount: comparison.numberOfMarks,
            source: { column: metricValue_1.TIMESTAMP_COLUMN_NAME },
            copy: [{ from: { column: metricValue_1.MEASURE_COLUMN_NAME }, to: { column: defaults_1.COMPARISON_MEASURE_COLUMN_NAME } }],
        };
    }
    else {
        return undefined;
    }
};
//# sourceMappingURL=index.js.map